import { generatePath } from 'react-router-dom';
import { createDatasetSlice, ResponseMapping } from 'src/redux/helpers';
import { pepApiRequest, RequestMethod } from 'src/services';
import {
  API_SOLUTION_GROUP_GET,
  SOLUTIONS_STORE,
  SOLUTIONS_STORE_GROUPS,
} from '../constants';

const api = (solutionId: string) =>
  pepApiRequest({
    method: RequestMethod.Get,
    url: generatePath(API_SOLUTION_GROUP_GET, { solutionId }),
  });

const solutionGroupsSlice = createDatasetSlice({
  api,
  storeName: SOLUTIONS_STORE,
  actionName: SOLUTIONS_STORE_GROUPS,
  responseMapping: ResponseMapping.Default,
});

export default solutionGroupsSlice;
